import { FilterNames, FilterOptions, SelectableOption, StringKey } from '../../common/filters/interfaces';
import { FilterType } from '../../common/domain/filterTypes';
import { SearchableField } from '../../common/filters/helper';
import { USER_TYPES } from '../../common/domain/userTypes';

export enum UserFilterNames {
  AccountId = 'accountId',
  AccountName = 'account.name',
  AccountManager = 'account.accountManager.id',
  AccountManagerName = 'account.accountManager.name',
  TeamId = 'teamId',
  TeamName = 'team.name',
  FirstLoginDate = 'firstLogin',
  LastLoginDate = 'lastLogin',
  LastLaunchDate = 'lastCampaignLaunchAt',
  CreationDate = 'createdAt',
  LastProjectCreatedAt = 'lastProjectCreatedAt',
  UserType = 'userType'
}

export const userKeyNames: Readonly<StringKey> = {
  [FilterNames.AccountName]: UserFilterNames.AccountId,
  [FilterNames.AccountManager]: UserFilterNames.AccountManager,
  [FilterNames.TeamName]: UserFilterNames.TeamId
};

export const filterOptions: SelectableOption[] = [
  { value: UserFilterNames.FirstLoginDate, label: 'First Login Date', type: FilterType.Date },
  { value: UserFilterNames.LastLoginDate, label: 'Last Login Date', type: FilterType.Date },
  { value: UserFilterNames.LastLaunchDate, label: 'Last Launch Date', type: FilterType.Date },
  { value: UserFilterNames.LastProjectCreatedAt, label: 'Last Project Create Date', type: FilterType.Date },
  { value: UserFilterNames.CreationDate, label: 'Creation Date', type: FilterType.Date },
  { value: UserFilterNames.UserType, label: 'User Access', type: FilterType.Text }
];

export const usersDropdownOptions: FilterOptions[] = [
  { fieldName: FilterNames.UserType, operators: USER_TYPES.sort((a, b) => a.displayOrder - b.displayOrder ) }
];

export const searchableFields: ReadonlyArray<SearchableField> = [
  FilterNames.FirstName,
  FilterNames.LastName,
  FilterNames.UserType,
  FilterNames.Email,
  UserFilterNames.AccountName,
  UserFilterNames.TeamName,
  UserFilterNames.AccountManagerName
];
